(ns frontend.ui.component.lp-portal.header.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn header
  []
  ^{:media {{:screen :only :max-width :599px}
            {:box-shadow      :none
             :justify-content :center}
            {:screen :only :max-width :1024px}
            {}}}

  {:display    :flex
   :background (theme/color [:header-bgr :primary :bg])
   :flex       "0 0 auto"
   :box-shadow "0 2px 5px rgba(166, 166, 166, .25)"
   :position   "sticky"
   :top        "0"
   :z-index    "20"})

(defn header-content
  []
  ^{:media
    {{:screen :only :max-width :599px}
     {:justify-content :start}}}
  {:padding         "10px 16px"
   :justify-content :space-between
   :align-items     :center
   :display         "flex"
   :flex            "1 1 auto"
   :width           "100%"
   :flex-direction  "row"
   :margin          "0 auto"})

(defn header-logo
  []
  (with-meta
    {:display "block"}
    {:media
     {{:screen :only :max-width :599px}
      {:display "none"}}}))

(defn header-menu
  []
  ^{:media
    {{:screen :only :max-width :599px}
     {:position :absolute
      :right    :8px}}}
  {:color     (theme/color [:header-bgr :primary :color])
   :font-size "20px"
   :cursor    "pointer"})

(defn header-logo-image-desktop
  []
  ^{:media
    {{:screen :only :max-width :599px}
     {}}}
  {:display    "block"
   :max-height (if (= :theme.lp-portal/sponsor-capital (theme/get-theme))
                 "52px"
                 "32px")})

(defn header-logo-image-mobile
  []
  ^{:media
    {{:screen :only :max-width :599px}
     {:display "none"}}}
  {:display     "none"
   :width       :72px
   :max-height  "32px"
   :padding-top :3px})

(defn admin-user-select
  []
  {:min-width 0
   :margin    "0px 33px 0px 15px"})
